/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { nodeProvidersGetApiV3NodeProvidersNodeProviderId } from "../../funcs/nodeProvidersGetApiV3NodeProvidersNodeProviderId.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetApiV3NodeProvidersNodeProviderIdRequest$inboundSchema,
};

export const tool$nodeProvidersGetApiV3NodeProvidersNodeProviderId:
  ToolDefinition<typeof args> = {
    name: "node-providers-get-api-v3-node-providers-node-provider-id",
    description: ``,
    args,
    tool: async (client, args, ctx) => {
      const [result, apiCall] =
        await nodeProvidersGetApiV3NodeProvidersNodeProviderId(
          client,
          args.request,
          { fetchOptions: { signal: ctx.signal } },
        ).$inspect();

      if (!result.ok) {
        return {
          content: [{ type: "text", text: result.error.message }],
          isError: true,
        };
      }

      const value = result.value;

      return formatResult(value, apiCall);
    },
  };
